<script >
export default {
  name: 'Bafylc',
  data() {
    return {
    }
  },
  created() {
  },
  mounted() {
  },
  methods: {
  }
}
</script>

<template>
  <div class="container">
    <p class="title" style="padding-top: 25px">1.出院病案复印流程</p>
    <div class="img-box">
      <img src="~@/assets/images/serviceGuide/cyba.png" width="100%" alt="">
    </div>
    <p class="tip">
      出院病案复印服务时间:工作日上午8:00-11:30 下午 13:30-17:00 <br>(不包括周末及法定节假日)
    </p>
    <p class="title">2.门(急)诊病案复印流程</p>
    <div class="img-box" style="padding-bottom: 10vw">
      <img src="~@/assets/images/serviceGuide/mzba.png" width="100%" alt="">
    </div>
  </div>
</template>

<style scoped lang="less">
.container{
  background: #fff;
  padding: 0 12px;
  .title{
    font-size: 0.18rem;
    color: #333;
    font-weight: bold;
    text-align: center;
    letter-spacing: 1px;
  }
  .tip{
    font-size: 13px;
    color: #333;
    text-align: center;
    line-height: 1.5;
    margin-bottom: 15vw;
    letter-spacing: 0.5px;
  }
}
.img-box {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 25px 0;
  background-color: #FFFFFF;
}
</style>
